export default function getProgressColor(value) {
  if (value >= 1) return "#21AD57"; // verde >=100%
  if (value <= 0.99) return "#DD405A"; //anamarillo >=51%
  /* if (value >= 0.81) return "#FDE498"; //anamarillo >=51%
  return "#DD405A"; // rojo <=50% */
}
